import React from 'react';
import { useTranscriber } from 'hooks';

export default (domain, keys = []) => Component => props => (
    <Component {...props} translations={useTranscriber(domain, keys)} />
);
